import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSortDesc(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M18 10a1 1 0 0 0-2 0v6.132l-1.445-.964a1 1 0 1 0-1.11 1.664L17 19l3.555-2.168a1 1 0 0 0-1.11-1.664L18 16.132V10ZM4 5a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4ZM4 9a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2H4ZM3 14a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM4 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      />
    </BaseIcon>
  );
}
